import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../lib/api-client';
import {ActionRequired} from '../types/ActionRequired';

export const useGetActionsRequired = () => {
    const { data, isLoading } = useQuery({
        queryKey: ['actions-required'],
        queryFn: async () => await apiClient.get('action-required/actions-required') as ActionRequired[]
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
